// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"efy1yH85jAELhES8l7b-c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 142
// module chunks = 0